import { useDesktopMediaQuery } from "app/shared/util/media-query";
import * as React from "react";
import { Image, StyleSheet, useWindowDimensions, View, ViewStyle } from "react-native";
import { Button, Text } from "react-native-paper";
import Animated, { interpolate, interpolateColor, useAnimatedStyle } from "react-native-reanimated";
import Carousel from "react-native-reanimated-carousel";
import { CarouselRenderItemInfo, ICarouselInstance } from "react-native-reanimated-carousel/lib/typescript/types";

interface ModalImageProps {
  image: string;
  imageRatio: number;
  buttonTitle?: string;
  onHideModal: () => void;
  onButton?: () => void;
}

const ModalImage = (props: ModalImageProps) => {
  const { onHideModal, image, imageRatio, buttonTitle, onButton } = props;
  const hideModal = () => {
    onHideModal();
  };

  const onPressButton = () => {
    onHideModal();
    if (onButton) onButton();
  };
  const isDesktop = useDesktopMediaQuery();
  const { width } = useWindowDimensions();
  const r = React.useRef<ICarouselInstance>(null);
  const [widthImage] = React.useState(width * 0.8 < 600 ? width * 0.8 : 600);

  const baseOptions = {
    vertical: isDesktop ? false : true,
    width: widthImage,
    height: widthImage / imageRatio,
    loop: false,
  };

  const animationStyle = React.useCallback(
    (value: number) => {
      "worklet";

      const zIndex = interpolate(value, [-1, 0, 1], [10, 20, 30]);
      const translateX = interpolate(value, [-2, 0, 1], [-baseOptions.width, 0, baseOptions.width]);

      return {
        transform: [{ translateX }],
        zIndex,
      };
    },
    [baseOptions.width],
  );

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: {
          flex: 1,
          borderRadius: 24,
        },
        itemContainer: { flex: 1 },
        image: {
          width: widthImage,
          height: widthImage / imageRatio,
        },
        animated: { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 },
        carousel: { borderRadius: 24 },
        textTitle: { color: "white", fontSize: 28, fontWeight: "600" },
      }),
    [widthImage, imageRatio],
  );

  const containerNow: ViewStyle = {
    paddingTop: 16,
    alignSelf: "center",
  };

  const renderItem = ({ animationValue, index, item }: CarouselRenderItemInfo<any>) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const maskStyle = useAnimatedStyle(() => {
      const backgroundColor = interpolateColor(animationValue.value, [-1, 0, 1], ["#000000dd", "transparent", "#000000dd"]);

      return {
        backgroundColor,
      };
    }, [animationValue]);

    return (
      <View key={index} style={styles.itemContainer}>
        <Image source={item.source} style={styles.image} />
        <Animated.View pointerEvents="none" style={[styles.animated, maskStyle]} />
      </View>
    );
  };

  return (
    <>
      <View style={styles.container}>
        <Text onPress={hideModal} style={styles.textTitle} children={"X"} />
        <Carousel
          {...baseOptions}
          ref={r}
          style={styles.carousel}
          scrollAnimationDuration={300}
          data={[{ key: 1, source: image }]}
          customAnimation={animationStyle}
          renderItem={renderItem}
        />

        <View style={containerNow}>
          <Button mode="contained" onPress={onPressButton} uppercase={false} children={buttonTitle} />
        </View>
      </View>
    </>
  );
};

export default ModalImage;
